<template>
    <div style="height:100%;overflow-y: auto">
        <div class="space-between flex-wrap main-field">
            <div class="center-menu-item">
                <div @click="toPage('/bindPatient')" class="space-between">
                    <div style="flex: 1;">绑定就诊号</div>
                    <div class="circle-type">
                        <img src="../assets/img/user.png"/>
                    </div>
                </div>
            </div>
            <div class="center-menu-item">
                <div @click="toPage('/registSubscribe')" class="space-between">
                    <div style="flex: 1;">预约挂号</div>
                    <div class="circle-type">
                        <img src="../assets/img/new_treatment.png"/>
                    </div>
                </div>
            </div>
            <div class="center-menu-item">
                <div @click="toPage('/subscribeInfo')" class="space-between">
                    <div style="flex: 1;">预约查询</div>
                    <div class="circle-type" style="padding: 6px">
                        <img src="../assets/img/yk_regist_query.png"/>
                    </div>
                </div>
            </div>
            <div class="center-menu-item">
                <div @click="toPage('/chargeDetail')" class="space-between">
                    <div style="flex: 1;">收费查询</div>
                    <div class="circle-type">
                        <img src="../assets/img/yk_fee.png"/>
                    </div>
                </div>
            </div>
            <div class="center-menu-item">
                <div @click="toPage('/caseSearch')" class="space-between">
                    <div style="flex: 1;">病例查询</div>
                    <div class="circle-type">
                        <img src="../assets/img/yk_bl.png"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, Toast} from 'mint-ui';

    export default {
        name: "OfficeCenter",
        data() {
            return {
                YY_USER_ID:""
            }
        },
        methods: {
            toPage: function (path) {
                this.$router.push({
                    path: path,
                    query: {
                        YY_USER_ID: this.$route.query.YY_USER_ID,
                        openId: this.$route.query.openId || this.openId
                    }
                })
            }
        },
        mounted() {
            var YY_USER_ID = this.$route.query.YY_USER_ID || "";
            if (YY_USER_ID) {
                this.YY_USER_ID = YY_USER_ID;
                this.$store.commit('set', {
                    YY_USER_ID: YY_USER_ID
                })
            }
        }
    }
</script>

<style scoped>
    .main-field {
        margin: 0 4px;
    }

    .center-menu-item {
        width: 50%;
    }

    .center-menu-item > div {
        margin: 8px 4px 0 4px;
        padding: 15px;
        background: white;
        border-radius: 4px;
        text-align: center;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .07);
        font-size: 20px;
    }

    .center-menu-item > div > div:first-child {
        font-size: 16px;
        letter-spacing: 3px;
        color: #777;
    }

    .circle-type {
        width: 40px;
        height: 40px;
        border-radius: 40px;
        background: #eaf9fd;
        padding: 7px;
        box-sizing: border-box;
    }

    .circle-type > img {
        display: inline-block;
        text-align: center;
    }
</style>